<div class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
  <div
    class="bg-white rounded-lg shadow-lg px-6 pt-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto pb-10"
  >
    <h2 class="text-xl font-semibold mb-4">{{ title }}</h2>
    <form [formGroup]="form" (ngSubmit)="formSubmit.emit()" class="space-y-5">
      <ng-container *ngFor="let f of fields">
        <app-input-text
          *ngIf="f.type === 'text' || !f.type"
          [label]="f.label"
          [placeholder]="f.placeholder ?? ''"
          [control]="form.get(f.name)"
        />
        <div class="my-4"></div>
        <app-input-select
          *ngIf="f.type === 'select'"
          [label]="f.label"
          [options]="f.options ?? []"
          [control]="form.get(f.name)"
        />
      </ng-container>
      <div class="flex justify-end gap-4 mt-6">
        <button
          type="button"
          class="px-4 py-2 bg-gray-200 rounded shadow"
          (click)="cancel.emit()"
        >
          Cancelar
        </button>
        <app-loading-button
          [text]="submitText"
          [loading]="loading"
          type="submit"
        >
        </app-loading-button>
      </div>
    </form>
  </div>
</div>
